<template>
  <modal name="transferencia-form-component"
  transition="nice-modal-fade"
  classes="demo-modal-class"
  :min-width="300"
  :min-height="200"
  :pivot-y="0.5"
  :adaptive="true"
  :scrollable="true"
  :reset="true"
  width="40%"
  height="auto"
  @before-open="beforeOpen"
  @opened="opened"
  @closed="closed"
  @before-close="beforeClose">


  <div class="modal-modern-wrapper">
    <div class="modal-header">
      <button type="button" class="close d-inline" aria-label="Close" @click="close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div>
        <h4 class="modal-title modern d-inline">NOVA TRANSFERÊNCIA</h4>
      </div>
    </div>
    <form class="modern" @submit.prevent="onSubmit()">
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-12">
              <div class="form-group">
                <label class="text-left" for="price">VALOR *</label>
                <money type="text" class="form-control" id="money-input" required v-model="model.value" placeholder="R$ 0,00" name="value" ></money>
              </div>

              <div class="form-group">
                <label for="name">DATA *</label>
                <input type="date" class="form-control" v-model="model.due_date" name="due_date" required>
              </div>

              <div class="form-group">
                <label for="name">DESCRIÇÃO</label>
                <input type="text" class="form-control bg-white" required v-model="model.name" name="name" >
              </div>
            </div>

            <div class="col-md-7 col-12">
              <div class="p-3" style="background-color: #f0f0f0"> 

                <div class="row">
                  <div class="col-md-12 col-12">
                    <div class="form-group">
                      <label for="name">ORIGEM *</label>
                      <select class="form-control" style="background-color: white;" v-model="model.origin_account_id" name="origin_account_id">
                        <option value="">Selecione o destino...</option>
                        <option v-for="item of accounts" :value="item.id">{{ item.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group">
                      <label for="name">DESTINO *</label>
                      <select class="form-control" style="background-color: white;" v-model="model.destination_account_id" name="destination_account_id">
                        <option value="">Selecione o destino...</option>
                        <option v-for="item of accounts" :value="item.id">{{ item.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn modern btn-secondary" @click="close()">CANCELAR</button>
        <button type="submit" class="btn modern btn-success" v-bind:class="{ disabled:  loading }">
          <span v-if="model.id">SALVAR</span>
          <span v-if="!model.id">CRIAR</span>
        </button>
      </div>
    </form>

  </div>

</modal>
</template>
<script>
  import AccountService from '@/services/AccountService'
  import OrderService from '@/services/OrderService'
  import Checkbox from '@/components/Inputs/Checkbox'
  import moment from 'moment'
  import Multiselect from 'vue-multiselect'
  export default {
    name: 'OrderFormComponent',
    components: {
      Checkbox,
      Multiselect
    },
    computed: {
      categoryId: {
        get() {
            return this.categories.find(category => this.model.category_id === category.id);
        },
        set(val) {
          if(val) {
            this.model.category_id = val.id;
          } else {
            this.model.category_id = null;
          }
        },
      }
    },
    data () {
      return {
        value: 0,
        model: {},
        addInformation: false,
        services: [],
        loading: false,
        categories: [],
        clientes: [],
        formErrors: {
          category: false,
        },
        accounts: [],
      }
    },
    methods: {
      beforeOpen (event) {
        this.model = Object.assign({})

        if(this.model.due_date) {
          this.model.due_date = moment(this.model.due_date).format('YYYY-MM-DD')
        }

        this.categoryId = { id: this.model.category_id }
      },
      beforeClose () {
      },
      opened (e) {
        this.formErrors.category = false;
        this.loadAccounts()
        let money = document.getElementById('money-input')
        money.focus()
      },
      closed (e) {
      },
      close() {
        this.$modal.hide('transferencia-form-component')
      },
      getPagamentoTipoNome(tipo) {
        if(tipo == "C") {
          return "Entrada"
        }
        if(tipo == "D") {
          return "Saída"
        }

        return '';
      },

      hasErrors() {
        let achou = false; 

        for (var prop in this.formErrors) {
          if (Object.prototype.hasOwnProperty.call(this.formErrors, prop)) {
            if(this.formErrors[prop] == true) {
              achou = true;
            }
          }
        }

        return achou;
      },

      onSubmit() {
        this.loading = true;

        OrderService.transferencia(this.model).then(res => {
          this.$emit('change')
          this.loading = false;
          this.close()
        })
        .catch(err => {
          this.loading = false;

        })
      },
      loadClientes() {
        ClienteService.load('?no_paginate=true').then(res => {
          this.clientes = res.data
        })
      },
      loadAccounts() {
        AccountService.load().then(res => {
          this.accounts = res.data
          if(res.data.length) {
            if(!this.model.id) {
              this.model.account_id = res.data[0].id
            }
          }
        })
        .catch(err => {
          console.error(err)
        })
      }
    },
    mounted() {

    }
  }
</script>
<style>
.size-modal-content {
  padding: 10px;
  font-style: 13px;
}
.v--modal-overlay[data-modal="size-modal"] {
  background: rgba(0, 0, 0, 0.5);
}
.demo-modal-class {
  border-radius: 5px;
  background: #FFFFFF;
  box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  z-index: 99999999;
  margin: 0 auto;
  left: 0 !important;
  margin-top: 20px;
  width: 60% !important;
  max-width: 750px;
}
.show{
  opacity: 1 !important;
}
.step{
  opacity: 0;
  transition: .5s ease-in-out all;
}

.modal-header h4 {
  position: absolute;
  left: 15px;
  top: -14px;
  font-size: 18px;
}

.ui.selection.dropdown {
  border-radius: 25px !important;
}
.multiselect__single {
  font-size: 12px !important;
}
.multiselect__input {
  font-size: 12px !important;
}
.multiselect__option {
  font-size: 12px !important;
}
.multiselect__tags {
  min-height: auto !important;
  border-radius: 20px !important;
  /*padding: 4px 40px 0 4px !important;*/
}

.modal-delete-area {
  position: absolute;
  left: 15px;
  bottom: 25px;
  padding: 10px;
  cursor: pointer;
}

.modal-delete-area:hover {
  background-color: #efefef;
}

.modal-delete-area.red {
  color: red;
}

.input-error {
  border: 1px solid red;
}

.input-error-multiselect > .multiselect__tags {
  border: 1px solid red;
}

.multiselect__tags {
  transition: border 1s;
}

@media (max-width: 600px) {
  .demo-modal-class {
    width: 90% !important;
  }
}
</style>